export default
[
  {
    path: '/Personal/Setting',
    component: () => import('@/views/PersonalCenter/Setting/Index'),
    name: 'Setting',
    meta: {
      title: '个人设置',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Setting/Form',
    component: () => import('@/views/PersonalCenter/Setting/Form'),
    name: 'Form',
    meta: {
      title: '表单设置',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Setting/Form/Franchisee',
    component: () => import('@/views/PersonalCenter/Setting/FormFranchisee'),
    name: 'FormFranchisee',
    meta: {
      title: '申请成为加盟商',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Setting/PhoneBind',
    component: () => import('@/views/PersonalCenter/Setting/PhoneBind'),
    name: 'PhoneBind',
    meta: {
      title: '修改绑定手机',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Setting/MoneyPay',
    component: () => import('@/views/PersonalCenter/Setting/MoneyPay'),
    name: 'MoneyPay',
    meta: {
      title: '在线支付充值',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Setting/Exchange',
    component: () => import('@/views/PersonalCenter/Setting/MoneyExchange'),
    name: 'MoneyExchange',
    meta: {
      title: '消费币兑换',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Setting/MoneyDetail',
    component: () => import('@/views/PersonalCenter/Setting/MoneyDetail'),
    name: 'MoneyDetail',
    meta: {
      title: '消费币明细',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  },
  {
    path: '/Personal/Setting/MoneyRecord',
    component: () => import('@/views/PersonalCenter/Setting/MoneyRecord'),
    name: 'MoneyRecord',
    meta: {
      title: '消费记录',
      noCache: false,
      affix: true,
      requireAuth: true
    }
  }
]
